"use client";

import { usePathname, useSearchParams } from "next/navigation";
import Script from "next/script";
import { useEffect } from "react";

declare global {
  interface Window {
    dataLayer: Record<string, unknown>[];
  }
}

export function GTM({ nonce }: { nonce: string }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (pathname) {
      pageview(pathname);
    }
  }, [pathname, searchParams]);

  if (
    process.env.NODE_ENV !== "production" ||
    process.env["NEXT_PUBLIC_TEST"]
  ) {
    return null;
  }

  return (
    <>
      <noscript>
        <iframe
          title="Google Tag Manager"
          src="/tm-ns"
          height="0"
          width="0"
          sandbox=""
          style={{ display: "none", visibility: "hidden" }}
        />
      </noscript>
      <Script
        id="gtm-script"
        strategy="afterInteractive"
        nonce={nonce}
        dangerouslySetInnerHTML={{
          __html: `
(function(w,d,s,l){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'/tm-js'+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer');
`,
        }}
      />
    </>
  );
}

function pageview(url: string) {
  window.dataLayer?.push({
    event: "page_view",
    page: url,
  });
}
